export const MODAL_TYPES = {
  NEW_DIAGRAM: 'NEW_DIAGRAM',
  NEW_FOLDER: 'NEW_FOLDER',
  OPEN_DISTRIBUTION_BOARD: 'OPEN_DISTRIBUTION_BOARD',
  EXPORT_EDITOR_EXCEL: 'EXPORT_EDITOR_EXCEL',
  EXPORT_EDITOR_PNG: 'EXPORT_EDITOR_PNG',
  EXPORT_EDITOR_DXF: 'EXPORT_EDITOR_DXF',
  EXPORT_EDITOR_PDF: 'EXPORT_EDITOR_PDF',
  EDITOR_SHORTCUTS: 'EDITOR_SHORTCUTS',
  EDITOR_SETTINGS: 'EDITOR_SETTINGS',
  CONFIRM_EXIT_PROJECTS: 'CONFIRM_EXIT_PROJECTS',
  KNOWLEDGE_TUTORIAL: 'KNOWLEDGE_TUTORIAL',
  KNOWLEDGE_VIDEO: 'KNOWLEDGE_VIDEO',
  AUTH_LOGIN: 'AUTH_LOGIN',
};
